export default __webpack_public_path__ + "static/media/sticker-B.f60d0506.png";